import { executeRecaptcha } from './utils/recaptcha.js';
import { disableForm, enableForm } from './utils/formState.js';

export function attachValidation(formElement, schema, errorMapping, onValidSubmit) {
  let isSubmitting = false;

  formElement.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (isSubmitting) return;

    // Clear all error messages first
    Object.values(errorMapping).forEach(id => {
      const el = document.getElementById(id);
      if (el) el.textContent = '';
    });

    if (formElement.classList.contains('careers-form')) {
      const fileInput = formElement.querySelector('input[type="file"]');
      if (!fileInput || !fileInput.files.length) {
        const errorEl = document.getElementById('error-cv-upload');
        if (errorEl) errorEl.textContent = 'CV upload is required';
        return;
      }
    }

    const formData = new FormData(formElement);
    const data = {};
    for (const [key, value] of formData.entries()) {
      data[key] = key === 'terms' ? formElement.querySelector('[name="terms"]').checked : value;
    }

    try {
      await schema.validate(data, { abortEarly: false });
      isSubmitting = true;
      disableForm(formElement);

      let token;
      try {
        token = await executeRecaptcha();
      } catch (err) {
        console.error('reCAPTCHA failed:', err);
        const recaptchaError = document.createElement('div');
        recaptchaError.className = 'form-error-message';
        recaptchaError.textContent = 'Verification failed. Please reload the page and try again.';
        formElement.appendChild(recaptchaError);
        isSubmitting = false;
        enableForm(formElement);
        return;
      }

      let tokenInput = formElement.querySelector('#recaptchaToken');
      if (!tokenInput) {
        tokenInput = document.createElement('input');
        tokenInput.type = 'hidden';
        tokenInput.name = 'recaptchaToken';
        tokenInput.id = 'recaptchaToken';
        formElement.appendChild(tokenInput);
      }
      tokenInput.value = token;

      onValidSubmit?.(formElement);
    } catch (validationError) {
      validationError.inner.forEach(err => {
        const errorId = errorMapping[err.path];
        const el = document.getElementById(errorId);
        if (el) el.textContent = err.message;
      });
    } finally {
      isSubmitting = false;
    }
  });
}